import { defineMessages } from 'react-intl';

export default defineMessages({
	confluencePage: {
		defaultMessage: 'Confluence page in {value}',
		description: 'Label showing a Confluence page result belongs to a specific space ({value})',
		id: 'cv.search.articles.metadata',
	},
});
